/**
 * Override display labels for icon IDs whose auto-generated names are unclear.
 * Keys are UPPER_SNAKE_CASE icon IDs. Values are the display strings shown in
 * tooltips, palette headers, and the asset list panel.
 */
export const ICON_LABEL_ALIASES: Record<string, string> = {
  // Facility
  FACILITY_AMMOSTORAGE: 'Ammo Storage',
  FACILITY_DRYDOCK: 'Dry Dock',
  FACILITY_IKF: 'IKF',
  FACILITY_LARGEPAD: 'Large Pad',
  FACILITY_MSUP: 'MSup',
  FACILITY_RAREMAT: 'Rare Mat',
  FACILITY_TRAINYARD: 'Train Yard',

  // Logistic
  LOGISTIC_MAINTENANCETUNNEL: 'Maintenance Tunnel',
  LOGISTIC_MSUP_5K: 'MSup 5K',
  LOGISTIC_MSUP_10K: 'MSup 10K',
  LOGISTIC_MSUP_30K: 'MSup 30K',
  LOGISTIC_STORAGEDEPOT: 'Storage Depot',
  LOGISTIC_AIRWAY: 'Airway',

  // Navy
  NAVY_LONGHOOK: 'Long Hook',

  // Operation — Info
  OPERATION_INFO_AIRDEPOT: 'Air Depot',
  OPERATION_INFO_AMMODEPOT: 'Ammo Depot',
  OPERATION_INFO_RALLYPOINT: 'Rally Point',
  OPERATION_INFO_SEAPORT: 'Sea Port',
  OPERATION_INFO_STORAGEDEPOT: 'Storage Depot',

  // Operation — Attack
  OPERATION_ATTACK_MAIN_OBJECTIVE: 'Main Objective',
  OPERATION_ATTACK_OBJECTIVE_1: 'Objective 1',
  OPERATION_ATTACK_OBJECTIVE_2: 'Objective 2',
  OPERATION_ATTACK_OBJECTIVE_3: 'Objective 3',
  OPERATION_ATTACK_OBJECTIVE_A: 'Objective A',
  OPERATION_ATTACK_OBJECTIVE_B: 'Objective B',
  OPERATION_ATTACK_OBJECTIVE_C: 'Objective C',

  // Operation — Defend
  OPERATION_DEFEND_MAIN_OBJECTIVE: 'Main Objective',
  OPERATION_DEFEND_OBJECTIVE_1: 'Objective 1',
  OPERATION_DEFEND_OBJECTIVE_2: 'Objective 2',
  OPERATION_DEFEND_OBJECTIVE_3: 'Objective 3',

  // Operation — Artillery
  OPERATION_ARTY_120: '120mm',
  OPERATION_ARTY_150: '150mm',
  OPERATION_ARTY_FIELDROCKET: 'Field Rocket',
  OPERATION_ARTY_HALFTRACKROCKET: 'Halftrack Rocket',
  OPERATION_ARTY_RSC: 'RSC',
  OPERATION_ARTY_SPG: 'SPG',

  // Operation — Build
  OPERATION_BUILD_PUSH: 'Push',
  OPERATION_BUILD_TAP: 'Tap',

  // Operation — Navy
  OPERATION_NAVY_FRIGATE: 'Frigate',
  OPERATION_NAVY_BATTLESHIP: 'Battleship',
  OPERATION_NAVY_BOWHEAD: 'Bowhead',
  OPERATION_NAVY_SUBMARINE: 'Submarine',
  OPERATION_NAVY_BLUEFIN: 'Bluefin',
  OPERATION_NAVY_LONGHOOK: 'Long Hook',
  OPERATION_NAVY_MERCY: 'Mercy',

  // Operation — Unit
  OPERATION_UNIT_INFANTRY: 'Infantry',
  OPERATION_UNIT_LOGISTIC: 'Logistics',

  // Operation — Vehicle
  OPERATION_VEHICLE_FIELDCANNON: 'Field Cannon',
  OPERATION_VEHICLE_HALFTRACK: 'Halftrack',
  OPERATION_VEHICLE_HALFTRACKAT: 'Halftrack AT',
  OPERATION_VEHICLE_RECON: 'Recon',
  OPERATION_VEHICLE_SPAA: 'SPAA',
  OPERATION_VEHICLE_TANK_LIGHT: 'Light Tank',
  OPERATION_VEHICLE_TANK_MEDIUM: 'Medium Tank',
  OPERATION_VEHICLE_TANK_HEAVY: 'Heavy Tank',
  OPERATION_VEHICLE_TANK_SUPERHEAVY: 'Super-Heavy Tank',

  BUILD_BASE: 'Base',
};
